import _request from '@/utils/request.js'

var _invoiceContent = {
  // 根据发票名称查询发票信息列表				
  getInvoiceListByPage (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/getInvoiceListByNamePage"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 根据发票名称查询发票信息列表				
  getInvoiceListByName (contentName, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/getInvoiceListByName"),
      params: {
        name: contentName
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  // 查询发票信息分页列表						
  getInvoiceList (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/getInvoiceList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },
  //查询关联税收分类
  getTaxCategoryList (query, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/getTaxCategoryList"),
      params: query,
      method: 'get',
      success: resolve,
      error: reject
    })
  },

  // 新增修改发票内容								
  addOrUpdateInvoice (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/addOrUpdateInvoice"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  //关联税收分类接口
  addOrUpdateCategory (info, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/addOrUpdateCategory"),
      data: info,
      method: 'post',
      success: resolve,
      error: reject
    })
  },
  // 查询发票详情										
  getInvoiceDetail (id, resolve, reject) {
    _request.api({
      url: _request.getCrmUrl("/api/invoice/getInvoiceDetail"),
      params: {
        id: id
      },
      method: 'get',
      success: resolve,
      error: reject
    })
  },

  // 查询发票详情										
  updateInvoiceState (id, state, resolve, reject) {
    _request.api({
       url: _request.getCrmUrl("/api/invoice/updateInvoiceState"),
      params: {
        id: id,
        state: state
      },
      method: 'post',
      success: resolve,
      error: reject
    })
    },
    // 查询特殊发票									
    getPageList (info,resolve, reject) {
        _request.api({
          url: _request.getFinanceUrl("/api/invoice/special/getPageList"),
          params:info,
          method: 'get',
          success: resolve,
          error: reject
        })
    },
     // 特殊发票内容创建与修改								
     createOrUpdate (info,resolve, reject) {
        _request.api({
          url: _request.getFinanceUrl("/api/invoice/special/createOrUpdate"),
          data:info,
          method: 'post',
          success: resolve,
          error: reject
        })
      }
}

export default _invoiceContent